import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Hoot from "../../Hoot";
import { toast } from "react-toastify";

import "bootstrap/dist/css/bootstrap.min.css";
import { Modal, Button, Tabs, Tab, Form, Spinner } from "react-bootstrap";

import { Avatar } from "@mui/material";

import {
  FiDollarSign,
  FiRefreshCw,
  FiPlus,
  FiEdit3,
  FiTrash2,
  FiPaperclip,
  FiSearch,
  FiUpload,
} from "react-icons/fi";

const styles = `
:root{
  --primary:#5b5cff;
  --primary2:#7c3aed;
  --bg:#f4f6fb;
  --card:#ffffff;
  --border:#e6eaf2;
  --text:#0f172a;
  --muted:#64748b;
  --shadow: 0 14px 40px rgba(15,23,42,.08);
}
.hr-shell{ background:var(--bg); padding:10px; }
.hr-card{
  background:var(--card);
  border-radius:18px;
  border:1px solid var(--border);
  padding:12px 14px 14px;
  box-shadow: var(--shadow);
}
.hr-header{
  display:flex;
  flex-wrap:wrap;
  justify-content:space-between;
  align-items:flex-start;
  gap:10px;
  margin-bottom:10px;
}
.hr-header-title{
  font-weight:700;
  font-size:1.02rem;
  display:flex;
  align-items:center;
  gap:.55rem;
  color:var(--text);
}
.hr-chip{
  display:inline-flex;
  align-items:center;
  gap:.35rem;
  padding:.28rem .62rem;
  border-radius:999px;
  background:linear-gradient(135deg, rgba(91,92,255,.14), rgba(124,58,237,.12));
  color:#4338ca;
  font-size:.78rem;
  font-weight:600;
  border:1px solid rgba(91,92,255,.16);
}
.small-muted{ font-size:.78rem; color:var(--muted); }

.hr-toolbar{
  margin-top:6px;
  padding:10px 10px;
  border-radius:14px;
  background:linear-gradient(180deg, rgba(148,163,184,0.12), rgba(148,163,184,0.06));
  border:1px solid rgba(226,232,240,.7);
  margin-bottom:10px;
}

.kpiRow{
  display:flex;
  gap:10px;
  flex-wrap:wrap;
  margin:10px 0 8px;
}
.kpi{
  flex:1;
  min-width:170px;
  border:1px solid var(--border);
  border-radius:16px;
  padding:10px 12px;
  background:rgba(148,163,184,0.06);
}
.kpiLabel{ color:var(--muted); font-size:.74rem; font-weight:850; }
.kpiValue{ font-weight:950; font-size:1.05rem; margin-top:2px; }

.hr-table-wrapper{ width:100%; }
@media (max-width:768px){
  .hr-table-desktop{display:none;}
  .hr-mobile-list{display:block;}
}
@media (min-width:769px){
  .hr-table-desktop{display:block;}
  .hr-mobile-list{display:none;}
}
.hr-table{
  width:100%;
  border-collapse:separate;
  border-spacing:0;
  font-size:.86rem;
  color:var(--text);
}
.hr-table thead th{
  text-align:left;
  padding:.62rem .65rem;
  font-size:.78rem;
  font-weight:650;
  color:var(--muted);
  border-bottom:1px solid var(--border);
  background:var(--card);
  position:sticky;
  top:0;
  z-index:1;
}
.hr-table tbody td{
  padding:.62rem .65rem;
  border-bottom:1px solid var(--border);
  vertical-align:middle;
}
.hr-table tbody tr:hover{ background:rgba(148,163,184,0.10); }

.pill{
  display:inline-flex;
  align-items:center;
  gap:6px;
  padding:4px 10px;
  border-radius:999px;
  font-size:.74rem;
  font-weight:600;
  border:1px solid rgba(15,23,42,.08);
  background:rgba(226,232,240,.55);
  color:#0f172a;
}
.status-badge{
  display:inline-flex;
  align-items:center;
  gap:8px;
  padding:6px 10px;
  border-radius:999px;
  font-size:.74rem;
  font-weight:650;
  border:1px solid rgba(0,0,0,.06);
  letter-spacing:.2px;
}
.status-dot{
  width:8px;height:8px;border-radius:999px;
  background:currentColor;
  box-shadow: 0 0 0 4px rgba(0,0,0,.04);
}
.s-paid{ background: rgba(34,197,94,.14); color:#22c55e; }
.s-pending{ background: rgba(245,158,11,.18); color:#f59e0b; }
.s-cancel{ background: rgba(239,68,68,.12); color:#ef4444; }
.s-other{ background: rgba(148,163,184,.18); color:#64748b; }

.btn-icon{
  width:34px;
  height:34px;
  border-radius:12px;
  border:1px solid rgba(226,232,240,.95);
  background:#fff;
  display:inline-grid;
  place-items:center;
  cursor:pointer;
  transition: transform .08s ease, background .12s ease;
}
.btn-icon:hover{ background: rgba(91,92,255,.06); }
.btn-icon:active{ transform: scale(.98); }
.btn-icon svg{ font-size:1.05rem; color:#334155; }
.actions-row{ display:flex; justify-content:flex-end; gap:8px; flex-wrap:wrap; }

.hr-mobile-list{ margin-top:4px; }
.mcard{
  background:var(--card);
  border-radius:16px;
  border:1px solid var(--border);
  padding:12px 12px;
  margin:8px 0;
  box-shadow: 0 10px 26px rgba(2,6,23,.06);
}
.mrow{ display:flex; align-items:center; justify-content:space-between; gap:12px; }
.mline{ height:1px; background:var(--border); margin:10px 0; }
.mtitle{ font-weight:650; color:var(--text); font-size:.92rem; }
.msub{ color:var(--muted); font-size:.78rem; margin-top:2px; display:flex; gap:8px; flex-wrap:wrap; }

.grid{
  display:grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap:12px;
  margin-top:10px;
}
@media (max-width:1200px){ .grid{ grid-template-columns: repeat(3, minmax(0, 1fr)); } }
@media (max-width:900px){ .grid{ grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width:520px){ .grid{ grid-template-columns: 1fr; } }

.gcard{
  background:var(--card);
  border:1px solid var(--border);
  border-radius:18px;
  box-shadow: 0 10px 26px rgba(2,6,23,.06);
  overflow:hidden;
}
.ghead{
  padding:12px 12px 10px;
  background:
    radial-gradient(900px 220px at 18% 0%, rgba(91,92,255,.14), transparent 60%),
    radial-gradient(780px 200px at 92% 0%, rgba(124,58,237,.10), transparent 55%),
    #ffffff;
  border-bottom:1px solid rgba(226,232,240,.9);
}
.gbody{ padding:10px 12px 12px; }
.gtitle{ font-weight:750; color:var(--text); font-size:.95rem; }
.gsub{ color:var(--muted); font-size:.78rem; margin-top:2px; display:flex; gap:8px; flex-wrap:wrap; }
.gactions{
  padding:10px 12px 12px;
  display:flex;
  gap:8px;
  justify-content:flex-end;
  border-top:1px solid rgba(226,232,240,.9);
  background:#fff;
}

.hr-footer{
  margin-top:10px;
  display:flex;
  justify-content:space-between;
  align-items:center;
  gap:10px;
  flex-wrap:wrap;
}

.pretty-modal .modal-dialog{ max-width: 820px; }
@media (max-width: 768px){ .pretty-modal .modal-dialog{ max-width: 96vw; } }
.pretty-modal .modal-content{
  border-radius: 18px;
  border: 1px solid rgba(226,232,240,.95);
  box-shadow: 0 30px 90px rgba(2,6,23,.22);
  overflow: hidden;
}
.pretty-modal .modal-header{
  border-bottom: 1px solid rgba(226,232,240,.9);
  background:
    radial-gradient(1000px 260px at 20% 0%, rgba(91,92,255,.16), transparent 60%),
    radial-gradient(900px 240px at 95% 0%, rgba(124,58,237,.12), transparent 55%),
    #ffffff;
  padding: 14px 16px;
}
.pretty-modal .modal-body{
  padding: 14px 16px 12px;
  background: linear-gradient(180deg, rgba(248,250,252,.75), #ffffff 40%);
}
.body-scroll{
  max-height: 520px;
  overflow-y: auto;
  padding-right: 4px;
}
.pretty-modal .modal-footer{
  border-top: 1px solid rgba(226,232,240,.9);
  padding: 12px 16px;
  background: #ffffff;
}
.header-row{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  flex-wrap:wrap;
}
.header-left{
  display:flex;
  align-items:center;
  gap:12px;
}
.icon-wrap{
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: rgba(91,92,255,.10);
  border: 1px solid rgba(91,92,255,.18);
  display:grid;
  place-items:center;
}
.title-sub{
  margin-top:2px;
  font-size: .8rem;
  color: #64748b;
  font-weight: 500;
}
.form-grid{
  display:grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 12px;
}
@media (max-width: 720px){ .form-grid{ grid-template-columns: 1fr; } }

.cardlet{
  background: rgba(255,255,255,.9);
  border: 1px solid rgba(226,232,240,.95);
  border-radius: 16px;
  padding: 10px 12px;
}
.cardlet-title{
  font-size: .78rem;
  color:#64748b;
  font-weight: 600;
  display:flex;
  align-items:center;
  gap:8px;
  margin-bottom: 8px;
}
.req{ color:#ef4444; font-weight:700; }

.form-control, .form-select{
  border-radius: 4px !important;
  border-color: rgba(226,232,240,.95) !important;
  padding-top: .55rem !important;
  padding-bottom: .55rem !important;
}
.form-control:focus, .form-select:focus{
  box-shadow: 0 0 0 .2rem rgba(91,92,255,.15) !important;
  border-color: rgba(91,92,255,.45) !important;
}

.helper{ font-size: .74rem; color:#64748b; margin-top: 6px; }
.actions{ display:flex; justify-content:flex-end; gap:10px; flex-wrap:wrap; }
.btn-soft{ border-radius: 999px !important; border: 1px solid rgba(226,232,240,.95) !important; background: #fff !important; }
.btn-primary{ border-radius: 999px !important; }
`;

function normalizeStrLocal(str) {
  return str ? str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() : "";
}
function safeValue(v, fallback = "—") {
  return v === null || v === undefined || v === "" ? fallback : v;
}
function statusClass(status) {
  const s = normalizeStrLocal(status);
  if (s === "pago") return "s-paid";
  if (s === "pendente") return "s-pending";
  if (s === "cancelado") return "s-cancel";
  return "s-other";
}
function buildPageButtonsLocal(currentOneBased, pageCount) {
  const current = currentOneBased;
  const maxButtons = 7;
  const pages = [];
  if (pageCount <= maxButtons) {
    for (let i = 1; i <= pageCount; i++) pages.push(i);
    return pages;
  }
  pages.push(1);
  let start = Math.max(2, current - 1);
  let end = Math.min(pageCount - 1, current + 1);
  if (start > 2) pages.push("...");
  for (let i = start; i <= end; i++) pages.push(i);
  if (end < pageCount - 1) pages.push("...");
  pages.push(pageCount);
  return pages;
}
function calcRangeText(page, limit, total) {
  if (!total) return "0";
  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);
  return `${start}-${end}`;
}
function asArray(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
}
async function fetchTechsSafe() {
  const candidates = ["techs/list", "techs", "technicians/list", "employees/techs", "hr/techs/list"];
  for (const path of candidates) {
    try {
      const res = await axios.get(Hoot() + path, { withCredentials: true });
      const arr = asArray(res.data);
      const norm = arr
        .map((t) => ({
          id: t?.id ?? t?.tech_id ?? t?.eduall_tech_id ?? "",
          name: t?.name ?? t?.tech_name ?? "",
        }))
        .filter((t) => t.id && t.name);
      if (norm.length) return norm;
    } catch {}
  }
  return [];
}

export default function HRPaymentsManager() {
  const [activeTab, setActiveTab] = useState("listagem");

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const [rows, setRows] = useState([]);
  const [techs, setTechs] = useState([]);

  const [q, setQ] = useState("");
  const [month, setMonth] = useState("");
  const [status, setStatus] = useState("all");

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);

  const [openPay, setOpenPay] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({
    tech_id: "",
    ref_month: "",
    base_salary: 0,
    bonus: 0,
    discount: 0,
    status: "pendente",
    note: "",
  });

  const [openDocs, setOpenDocs] = useState(false);
  const [docsRow, setDocsRow] = useState(null);
  const [docTitle, setDocTitle] = useState("");
  const [docNote, setDocNote] = useState("");
  const [docFiles, setDocFiles] = useState([]);

  const load = async () => {
    try {
      setLoading(true);
      setError(null);

      const [pRes, tRes] = await Promise.allSettled([
        axios.get(Hoot() + "hr/payments/list", { withCredentials: true }),
        fetchTechsSafe(),
      ]);

      if (pRes.status === "fulfilled") setRows(asArray(pRes.value.data));
      else setRows([]);

      if (tRes.status === "fulfilled") setTechs(tRes.value || []);
      else setTechs([]);
    } catch {
      setError("Erro ao carregar RH/Contabilidade.");
      setRows([]);
      setTechs([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const filtered = useMemo(() => {
    const s = normalizeStrLocal(q || ""); //  corrigido aqui
    return (rows || []).filter((r) => {
      if (month && normalizeStrLocal(r.ref_month) !== normalizeStrLocal(month)) return false;
      if (status !== "all" && normalizeStrLocal(r.status) !== normalizeStrLocal(status)) return false;

      const hay = [r.tech_name, r.ref_month, r.status, r.note]
        .map((x) => normalizeStrLocal(x))
        .join(" ");
      return !s || hay.includes(s);
    });
  }, [rows, q, month, status]);

  const total = filtered.length;
  const pageCount = useMemo(() => Math.max(1, Math.ceil((total || 0) / (limit || 1))), [total, limit]);
  const pageButtons = useMemo(() => buildPageButtonsLocal(page, pageCount), [page, pageCount]);
  const rangeText = useMemo(() => calcRangeText(page, limit, total), [page, limit, total]);

  useEffect(() => {
    if (page > pageCount) setPage(pageCount);
  }, [page, pageCount]);

  const pageSlice = useMemo(() => {
    const start = (page - 1) * limit;
    return filtered.slice(start, start + limit);
  }, [filtered, page, limit]);

  const kpis = useMemo(() => {
    const paid = filtered.filter((r) => normalizeStrLocal(r.status) === "pago").length;
    const pending = filtered.filter((r) => normalizeStrLocal(r.status) === "pendente").length;
    const sumNet = filtered.reduce((acc, r) => {
      const base = Number(r.base_salary || 0);
      const bonus = Number(r.bonus || 0);
      const disc = Number(r.discount || 0);
      return acc + (base + bonus - disc);
    }, 0);
    return { paid, pending, sumNet };
  }, [filtered]);

  const openCreate = () => {
    setEditing(null);
    setForm({
      tech_id: "",
      ref_month: month || "",
      base_salary: 0,
      bonus: 0,
      discount: 0,
      status: "pendente",
      note: "",
    });
    setOpenPay(true);
  };

  const openEdit = (row) => {
    setEditing(row);
    setForm({
      tech_id: row.tech_id || "",
      ref_month: row.ref_month || "",
      base_salary: row.base_salary ?? 0,
      bonus: row.bonus ?? 0,
      discount: row.discount ?? 0,
      status: row.status || "pendente",
      note: row.note || "",
    });
    setOpenPay(true);
  };

  const closePay = () => {
    if (saving) return;
    setOpenPay(false);
    setEditing(null);
    setError(null);
  };

  const savePayment = async () => {
    if (!form.tech_id) { setError("Selecione um técnico."); return; }
    if (!form.ref_month) { setError("Defina o mês (YYYY-MM)."); return; }

    try {
      setSaving(true);
      setError(null);

      const payload = {
        ...form,
        base_salary: Number(form.base_salary || 0),
        bonus: Number(form.bonus || 0),
        discount: Number(form.discount || 0),
      };

      if (editing?.id) {
        await axios.put(Hoot() + `hr/payments/${editing.id}`, payload, { withCredentials: true });
        toast.success("Pagamento atualizado.");
      } else {
        await axios.post(Hoot() + "hr/payments/create", payload, { withCredentials: true });
        toast.success("Pagamento registado.");
      }

      closePay();
      await load();
    } catch {
      setError("Erro ao guardar pagamento.");
    } finally {
      setSaving(false);
    }
  };

  const deletePayment = async (row) => {
    if (!window.confirm("Remover este registo de pagamento?")) return;
    try {
      setSaving(true);
      setError(null);
      await axios.delete(Hoot() + `hr/payments/${row.id}`, { withCredentials: true });
      toast.success("Pagamento removido.");
      await load();
    } catch {
      setError("Erro ao remover pagamento.");
    } finally {
      setSaving(false);
    }
  };

  const startDocs = (row) => {
    setDocsRow(row);
    setDocTitle("");
    setDocNote("");
    setDocFiles([]);
    setOpenDocs(true);
  };

  const closeDocs = () => {
    if (saving) return;
    setOpenDocs(false);
    setDocsRow(null);
    setDocTitle("");
    setDocNote("");
    setDocFiles([]);
  };

  const uploadDocs = async () => {
    if (!docsRow?.id) return;
    if (!docTitle.trim()) { setError("Título é obrigatório."); return; }
    if (!docFiles.length) { setError("Selecione pelo menos 1 ficheiro."); return; }

    try {
      setSaving(true);
      setError(null);

      const fd = new FormData();
      fd.append("title", docTitle);
      fd.append("note", docNote);
      for (const f of docFiles) fd.append("files", f);

      await axios.post(Hoot() + `hr/payments/${docsRow.id}/docs/upload`, fd, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("Anexos enviados.");
      closeDocs();
      await load();
    } catch {
      setError("Erro ao enviar anexos.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <style>{styles}</style>

      <div className="hr-shell">
        <div className="hr-card">
          <div className="hr-header">
            <div className="hr-header-title">
              <FiDollarSign style={{ color: "var(--primary)", fontSize: 20 }} />
              <span>RH / Contabilidade</span>
              <span className="hr-chip">{total} registos</span>
            </div>

            <div className="d-flex flex-wrap gap-2">
              <button
                className="btn btn-outline-dark btn-sm rounded-pill d-flex align-items-center"
                onClick={load}
                disabled={loading}
              >
                <FiRefreshCw className="me-2" />
                Recarregar
              </button>

              <button
                className="btn btn-outline-primary btn-sm rounded-pill d-flex align-items-center"
                onClick={openCreate}
                disabled={saving}
              >
                <FiPlus className="me-2" />
                Registar
              </button>
            </div>
          </div>

          {error ? (
            <div className="alert alert-danger py-2 mb-2" style={{ borderRadius: 14 }}>
              {error}
            </div>
          ) : null}

          <div className="kpiRow">
            <div className="kpi">
              <div className="kpiLabel">Pagos</div>
              <div className="kpiValue">{kpis.paid}</div>
            </div>
            <div className="kpi">
              <div className="kpiLabel">Pendentes</div>
              <div className="kpiValue">{kpis.pending}</div>
            </div>
            <div className="kpi">
              <div className="kpiLabel">Total líquido</div>
              <div className="kpiValue">{Number(kpis.sumNet || 0).toLocaleString("pt-PT")} Kz</div>
            </div>
          </div>

          <div className="hr-toolbar">
            <div className="row g-2 align-items-center">
              <div className="col-12 col-md-6">
                <div className="input-group input-group-sm">
                  <span className="input-group-text bg-white"><FiSearch /></span>
                  <input
                    type="search"
                    className="form-control form-control-sm"
                    placeholder="Pesquisar (técnico, mês, nota...)"
                    value={q}
                    onChange={(e) => { setQ(e.target.value); setPage(1); }}
                  />
                </div>
              </div>

              <div className="col-6 col-md-2">
                <input
                  className="form-control form-control-sm"
                  type="month"
                  value={month}
                  onChange={(e) => { setMonth(e.target.value); setPage(1); }}
                />
              </div>

              <div className="col-6 col-md-2">
                <Form.Select size="sm" value={status} onChange={(e) => { setStatus(e.target.value); setPage(1); }}>
                  <option value="all">Todos estados</option>
                  <option value="pendente">Pendente</option>
                  <option value="pago">Pago</option>
                  <option value="cancelado">Cancelado</option>
                </Form.Select>
              </div>

              <div className="col-12 col-md-2">
                <Form.Select size="sm" value={limit} onChange={(e) => { setLimit(Number(e.target.value || 20)); setPage(1); }}>
                  <option value={10}>10 / pág</option>
                  <option value={20}>20 / pág</option>
                  <option value={30}>30 / pág</option>
                  <option value={50}>50 / pág</option>
                </Form.Select>
              </div>

              {techs.length === 0 ? (
                <div className="col-12">
                  <div className="small-muted">
                    Aviso: lista de técnicos não carregou (sem endpoint). A listagem funciona porque vem <b>tech_name</b> do backend.
                  </div>
                </div>
              ) : null}
            </div>
          </div>

          <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k || "listagem")} className="mb-2">
            <Tab eventKey="listagem" title="Listagem">
              <div className="hr-table-wrapper">
                <div className="hr-table-desktop">
                  <div style={{ overflowX: "auto" }}>
                    <table className="hr-table">
                      <thead>
                        <tr>
                          <th>Mês</th>
                          <th>Técnico</th>
                          <th>Base</th>
                          <th>Bónus</th>
                          <th>Desconto</th>
                          <th>Líquido</th>
                          <th>Estado</th>
                          <th>Anexos</th>
                          <th className="text-end">Ações</th>
                        </tr>
                      </thead>

                      <tbody>
                        {pageSlice.map((r) => {
                          const net = Number(r.base_salary || 0) + Number(r.bonus || 0) - Number(r.discount || 0);
                          return (
                            <tr key={r.id}>
                              <td><span className="pill">{safeValue(r.ref_month)}</span></td>
                              <td style={{ fontWeight: 650 }}>
                                <div className="d-flex align-items-center gap-2">
                                  <Avatar variant="rounded" sx={{ width: 34, height: 34, borderRadius: 2 }} />
                                  <span>{safeValue(r.tech_name, "—")}</span>
                                </div>
                              </td>
                              <td>{Number(r.base_salary || 0).toLocaleString("pt-PT")} Kz</td>
                              <td>{Number(r.bonus || 0).toLocaleString("pt-PT")} Kz</td>
                              <td>{Number(r.discount || 0).toLocaleString("pt-PT")} Kz</td>
                              <td style={{ fontWeight: 750 }}>{net.toLocaleString("pt-PT")} Kz</td>
                              <td>
                                <span className={`status-badge ${statusClass(r.status)}`}>
                                  <span className="status-dot" />
                                  {safeValue(r.status)}
                                </span>
                              </td>
                              <td>
                                <span className="pill"><FiPaperclip /> {r.docs_count ?? 0}</span>
                              </td>
                              <td className="text-end">
                                <div className="actions-row">
                                  <button className="btn-icon" title="Anexos" onClick={() => startDocs(r)} disabled={saving}>
                                    <FiPaperclip />
                                  </button>
                                  <button className="btn-icon" title="Editar" onClick={() => openEdit(r)} disabled={saving}>
                                    <FiEdit3 />
                                  </button>
                                  <button className="btn-icon" title="Remover" onClick={() => deletePayment(r)} disabled={saving}>
                                    <FiTrash2 style={{ color: "#ef4444" }} />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}

                        {pageSlice.length === 0 ? (
                          <tr><td colSpan={9}><span className="small-muted">{loading ? "A carregar..." : "Sem dados."}</span></td></tr>
                        ) : null}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="hr-mobile-list">
                  {pageSlice.map((r) => {
                    const net = Number(r.base_salary || 0) + Number(r.bonus || 0) - Number(r.discount || 0);
                    return (
                      <div className="mcard" key={r.id}>
                        <div className="mrow">
                          <div>
                            <div className="mtitle">{safeValue(r.tech_name, "—")}</div>
                            <div className="msub">
                              <span className="pill">{safeValue(r.ref_month)}</span>
                              <span className="pill">{net.toLocaleString("pt-PT")} Kz</span>
                            </div>
                          </div>

                          <div className={`status-badge ${statusClass(r.status)}`}>
                            <span className="status-dot" />
                            {safeValue(r.status)}
                          </div>
                        </div>

                        <div className="mline" />

                        <div className="d-flex flex-wrap gap-2">
                          <span className="pill">Base: {Number(r.base_salary || 0).toLocaleString("pt-PT")} Kz</span>
                          <span className="pill">Bónus: {Number(r.bonus || 0).toLocaleString("pt-PT")} Kz</span>
                          <span className="pill">Desc.: {Number(r.discount || 0).toLocaleString("pt-PT")} Kz</span>
                          <span className="pill"><FiPaperclip /> {r.docs_count ?? 0}</span>
                        </div>

                        <div className="mline" />

                        <div className="d-flex justify-content-end gap-2">
                          <button className="btn-icon" title="Anexos" onClick={() => startDocs(r)} disabled={saving}>
                            <FiPaperclip />
                          </button>
                          <button className="btn-icon" title="Editar" onClick={() => openEdit(r)} disabled={saving}>
                            <FiEdit3 />
                          </button>
                          <button className="btn-icon" title="Remover" onClick={() => deletePayment(r)} disabled={saving}>
                            <FiTrash2 style={{ color: "#ef4444" }} />
                          </button>
                        </div>
                      </div>
                    );
                  })}

                  {pageSlice.length === 0 ? <span className="small-muted">{loading ? "A carregar..." : "Sem dados."}</span> : null}
                </div>
              </div>

              <div className="hr-footer">
                <div className="small-muted">
                  Mostrando <b>{rangeText}</b> de <b>{total}</b>
                </div>

                {pageCount > 1 ? (
                  <nav>
                    <ul className="pagination pagination-sm mb-0">
                      <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                        <button className="page-link" onClick={() => setPage((p) => Math.max(1, p - 1))}>«</button>
                      </li>

                      {pageButtons.map((p, idx) =>
                        p === "..." ? (
                          <li key={`e-${idx}`} className="page-item disabled"><span className="page-link">…</span></li>
                        ) : (
                          <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
                            <button className="page-link" onClick={() => setPage(p)}>{p}</button>
                          </li>
                        )
                      )}

                      <li className={`page-item ${page === pageCount ? "disabled" : ""}`}>
                        <button className="page-link" onClick={() => setPage((p) => Math.min(pageCount, p + 1))}>»</button>
                      </li>
                    </ul>
                  </nav>
                ) : null}
              </div>
            </Tab>

            <Tab eventKey="grid" title="Grid">
              <div className="grid">
                {pageSlice.map((r) => {
                  const net = Number(r.base_salary || 0) + Number(r.bonus || 0) - Number(r.discount || 0);
                  return (
                    <div className="gcard" key={r.id}>
                      <div className="ghead">
                        <div className="d-flex align-items-center gap-2">
                          <Avatar variant="rounded" sx={{ width: 52, height: 52, borderRadius: 4 }} />
                          <div style={{ flex: 1 }}>
                            <div className="gtitle">{safeValue(r.tech_name, "—")}</div>
                            <div className="gsub">
                              <span className="pill">{safeValue(r.ref_month)}</span>
                              <span className={`status-badge ${statusClass(r.status)}`}>
                                <span className="status-dot" />
                                {safeValue(r.status)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="gbody">
                        <div className="gsub">
                          <span className="pill">Base: {Number(r.base_salary || 0).toLocaleString("pt-PT")} Kz</span>
                          <span className="pill">Bónus: {Number(r.bonus || 0).toLocaleString("pt-PT")} Kz</span>
                          <span className="pill">Desc.: {Number(r.discount || 0).toLocaleString("pt-PT")} Kz</span>
                          <span className="pill"><FiDollarSign /> Líquido: {net.toLocaleString("pt-PT")} Kz</span>
                          <span className="pill"><FiPaperclip /> {r.docs_count ?? 0} anexos</span>
                        </div>
                      </div>

                      <div className="gactions">
                        <button className="btn-icon" title="Anexos" onClick={() => startDocs(r)} disabled={saving}>
                          <FiPaperclip />
                        </button>
                        <button className="btn-icon" title="Editar" onClick={() => openEdit(r)} disabled={saving}>
                          <FiEdit3 />
                        </button>
                        <button className="btn-icon" title="Remover" onClick={() => deletePayment(r)} disabled={saving}>
                          <FiTrash2 style={{ color: "#ef4444" }} />
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>

              {pageSlice.length === 0 ? <div className="small-muted mt-2">{loading ? "A carregar..." : "Sem dados."}</div> : null}
            </Tab>
          </Tabs>
        </div>
      </div>

      {/* MODAL PAGAMENTO */}
      <Modal show={openPay} onHide={closePay} centered backdrop="static" keyboard={!saving} className="pretty-modal">
        <Modal.Header closeButton={!saving}>
          <div className="header-row" style={{ width: "100%" }}>
            <div className="header-left">
              <div className="icon-wrap">
                <FiDollarSign style={{ color: "#5b5cff", fontSize: 18 }} />
              </div>
              <div>
                <div style={{ fontWeight: 650 }}>{editing ? "Editar pagamento" : "Registar pagamento"}</div>
                <div className="title-sub">Defina salário base, bónus, descontos e estado.</div>
              </div>
            </div>
            <span className="pill">{safeValue(form.ref_month || month || "YYYY-MM")}</span>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="body-scroll">
            {error ? (
              <div className="alert alert-danger py-2 mb-3" style={{ borderRadius: 14 }}>{error}</div>
            ) : null}

            <Form>
              <div className="form-grid">
                <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                  <div className="cardlet-title"><FiDollarSign /> Pagamento</div>

                  <div className="form-grid">
                    <Form.Group>
                      <Form.Label>Técnico <span className="req">*</span></Form.Label>
                      <Form.Select
                        value={form.tech_id}
                        onChange={(e) => setForm((p) => ({ ...p, tech_id: e.target.value }))}
                        disabled={saving}
                      >
                        <option value="">— selecionar —</option>
                        {techs.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
                      </Form.Select>
                    </Form.Group>

                    <Form.Group>
                      <Form.Label>Mês (YYYY-MM) <span className="req">*</span></Form.Label>
                      <Form.Control
                        type="month"
                        value={form.ref_month}
                        onChange={(e) => setForm((p) => ({ ...p, ref_month: e.target.value }))}
                      />
                    </Form.Group>
                  </div>
                </div>

                <div className="cardlet">
                  <div className="cardlet-title">Valores</div>

                  <Form.Group className="mb-2">
                    <Form.Label>Salário base (Kz)</Form.Label>
                    <Form.Control type="number" value={form.base_salary} onChange={(e) => setForm((p) => ({ ...p, base_salary: e.target.value }))} />
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label>Bónus (Kz)</Form.Label>
                    <Form.Control type="number" value={form.bonus} onChange={(e) => setForm((p) => ({ ...p, bonus: e.target.value }))} />
                  </Form.Group>

                  <Form.Group>
                    <Form.Label>Desconto (Kz)</Form.Label>
                    <Form.Control type="number" value={form.discount} onChange={(e) => setForm((p) => ({ ...p, discount: e.target.value }))} />
                  </Form.Group>
                </div>

                <div className="cardlet">
                  <div className="cardlet-title">Estado & Nota</div>

                  <Form.Group className="mb-2">
                    <Form.Label>Estado</Form.Label>
                    <Form.Select value={form.status} onChange={(e) => setForm((p) => ({ ...p, status: e.target.value }))}>
                      <option value="pendente">Pendente</option>
                      <option value="pago">Pago</option>
                      <option value="cancelado">Cancelado</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group>
                    <Form.Label>Nota</Form.Label>
                    <Form.Control value={form.note} onChange={(e) => setForm((p) => ({ ...p, note: e.target.value }))} placeholder="Opcional..." />
                  </Form.Group>
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="actions" style={{ width: "100%" }}>
            <Button variant="outline-secondary" className="btn-soft" onClick={closePay} disabled={saving}>Cancelar</Button>
            <Button variant="primary" onClick={savePayment} disabled={saving}>
              {saving ? (<><Spinner animation="border" size="sm" className="me-2" />A guardar...</>) : (editing ? "Atualizar" : "Registar")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* MODAL DOCS */}
      <Modal show={openDocs} onHide={closeDocs} centered backdrop="static" keyboard={!saving} className="pretty-modal">
        <Modal.Header closeButton={!saving}>
          <div className="header-row" style={{ width: "100%" }}>
            <div className="header-left">
              <div className="icon-wrap">
                <FiPaperclip style={{ color: "#5b5cff", fontSize: 18 }} />
              </div>
              <div>
                <div style={{ fontWeight: 650 }}>Anexos do pagamento</div>
                <div className="title-sub">
                  Técnico: <b>{docsRow?.tech_name || "—"}</b> • Mês: <b>{docsRow?.ref_month || "—"}</b>
                </div>
              </div>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="body-scroll">
            {error ? (
              <div className="alert alert-danger py-2 mb-3" style={{ borderRadius: 14 }}>{error}</div>
            ) : null}

            <Form>
              <div className="form-grid">
                <div className="cardlet">
                  <div className="cardlet-title"><FiPaperclip /> Documento</div>

                  <Form.Group className="mb-2">
                    <Form.Label>Título <span className="req">*</span></Form.Label>
                    <Form.Control value={docTitle} onChange={(e) => setDocTitle(e.target.value)} placeholder="Ex.: Recibo / Comprovativo..." />
                  </Form.Group>

                  <Form.Group>
                    <Form.Label>Nota</Form.Label>
                    <Form.Control value={docNote} onChange={(e) => setDocNote(e.target.value)} placeholder="Opcional..." />
                  </Form.Group>
                </div>

                <div className="cardlet">
                  <div className="cardlet-title"><FiUpload /> Ficheiros</div>
                  <Form.Group>
                    <Form.Label>Selecionar (múltiplos)</Form.Label>
                    <Form.Control type="file" multiple onChange={(e) => setDocFiles(Array.from(e.target.files || []))} />
                    <div className="helper">
                      {docFiles.length ? `${docFiles.length} ficheiro(s) selecionado(s).` : "Nenhum ficheiro selecionado."}
                    </div>
                  </Form.Group>
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="actions" style={{ width: "100%" }}>
            <Button variant="outline-secondary" className="btn-soft" onClick={closeDocs} disabled={saving}>Cancelar</Button>
            <Button variant="primary" onClick={uploadDocs} disabled={saving}>
              {saving ? (<><Spinner animation="border" size="sm" className="me-2" />A enviar...</>) : "Enviar"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
